export default __webpack_public_path__ + "static/5-0c58bf43e6aac359a4d6ac0679d2bbaf.webp";